import {
  EDITOR_DELETE_ASSET_BEGIN,
  EDITOR_DELETE_ASSET_SUCCESS,
  EDITOR_DELETE_ASSET_FAILURE,
  EDITOR_DELETE_ASSET_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { toast } from 'react-toastify';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function deleteAsset(args = {}) {
  return (dispatch) => {
    dispatch({
      type: EDITOR_DELETE_ASSET_BEGIN,
    });
    const { projectId, version, assetId } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.delete(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/assets/${projectId}/${assetId}`,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200) {
            dispatch({
              type: EDITOR_DELETE_ASSET_SUCCESS,
              data: assetId,
            });
            toast.success('Asset deleted successfully !');
            resolve(res);
          } else {
            dispatch({
              type: EDITOR_DELETE_ASSET_FAILURE,
              data: { error: 'Failed' },
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: EDITOR_DELETE_ASSET_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissDeleteAssetError() {
  return {
    type: EDITOR_DELETE_ASSET_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case EDITOR_DELETE_ASSET_BEGIN:
      return {
        ...state,
        deleteAssetPending: true,
        deleteAssetError: null,
      };

    case EDITOR_DELETE_ASSET_SUCCESS:
      return {
        ...state,
        deleteAssetPending: false,
        deleteAssetError: null,
        assets: action.data ? state.assets.filter((e) => e.uuid !== action.data) : [],
        showBuilderCanvasLoader: false,
      };

    case EDITOR_DELETE_ASSET_FAILURE:
      return {
        ...state,
        deleteAssetPending: false,
        deleteAssetError: action.data.error,
      };

    case EDITOR_DELETE_ASSET_DISMISS_ERROR:
      return {
        ...state,
        deleteAssetError: null,
      };

    default:
      return state;
  }
}
